import React from 'react';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers';
import { classNameBuilder } from '../../utilities';

interface DatePickerProps {
  id?: string;
  error?: boolean;
  label?: string;
  value?: Date;
  className?: string;
  onChange?: (
    value: Date | null | undefined,
    keyboardInputValue?: string | undefined
  ) => void;
  disabled?: boolean;
  readOnly?: boolean;
  minDate?: Date; // new prop for minimum start date
}

export default function DatePicker({
  label,
  value,
  className,
  id,
  onChange,
  error,
  disabled,
  readOnly,
  minDate, // new prop for minimum start date
  ...props
}: DatePickerProps) {
  return (
    <MUIDatePicker
      {...props}
      className={classNameBuilder(
        'h-app-date-field',
        readOnly ? 'readonly' : '',
        className ?? ''
      )}
      label={label}
      value={value}
      onChange={(date) => {
        if (onChange) onChange(date);
      }}
      disabled={disabled}
      readOnly={readOnly}
      minDate={minDate} // set the minDate prop
    />
  );
}
